<template>
  <v-container class="tela-cargos">
    <v-form>
      <input
        id="user-id"
        type="hidden"
        v-model="cargo.usuario"
      />
      <input
        id="estrutura-id"
        type="hidden"
        v-model="cargo.id"
      />
      <input
        id="estrutura-uuid"
        type="hidden"
        v-model="cargo.uuid"
      />
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            dense
            outlined
          >
            <v-btn
              class="btn-outer-right pa-0"
              slot="append"
              color="success"
              tile
              @click.prevent="loadDialog"
            >
              <v-icon
                class="mx-0"
                color="white"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
          v-if="codigo"
        >
          <v-checkbox
            v-model="cargo.inativar"
            label="Inativar cargo?"
            color="success"
            v-show="mode === 'save'"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          lg="7"
          md="8"
        >
          <v-text-field
            v-model="cargo.cargo"
            label="Nome do cargo"
            required
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          lg="5"
          md="4"
        >
          <v-autocomplete
            v-model="cargo.uid_sessao"
            :items="sessao"
            required
            dense
            outlined
            label="Sessão do cargo"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-card>
        <v-tabs
          background-color="primary"
          dark
          v-model="tabs"
        >
          <v-tab>
            <v-icon class="mr-2">
              mdi-message-text-outline
            </v-icon>
            Atribuições
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card class="pa-2">
                    <ckeditor
                      :editor="editor"
                      v-model="cargo.ds_cargo"
                      :config="editorConfig"
                      placeholder="Atribuições para o cargo"
                    ></ckeditor>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-btn
            color="success"
            class="mr-4"
            v-if="mode === 'save'"
            @click="save"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
          <v-btn
            color="error"
            class="mr-4"
            v-if="mode === 'remove'"
            @click="remove"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Deletar
          </v-btn>
          <v-btn
            color="secondary"
            class="mr-4"
            @click="reset"
          >
            <v-icon left>
              mdi-broom
            </v-icon>
            Limpar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog
          v-model="dialog"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="cargos"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadCargo(item)"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon
                    medium
                    color="error"
                    class="mr-2"
                    @click="loadCargo(item, 'remove')"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialog.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
export default {
  name: 'TelaCargos',
  computed: mapState(['user']),
  data: () => ({
    editor: ClassicEditor,
    editorConfig: {
    },
    uuid: '',
    tabs: null,
    btn: false,
    codigo: '',
    dialog: false,
    mode: 'save',
    cargo: {},
    cargos: [],
    length: '',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome do cargo', value: 'cargo' },
      { text: 'Sessão do cargo', value: 'sessao' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    sessao: [
      { text: 'Vereadores', value: 1 },
      { text: 'Comissões', value: 2 },
      { text: 'Outras', value: 3 },
      { text: 'Gestão', value: 4 },
      { text: 'Conselhos', value: 5 }
    ]
  }),
  methods: {
    endereco () {

    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      const method = this.cargo.id ? 'put' : 'post'
      const id = this.cargo.id ? `/${this.cargo.id}` : ''
      axios[method](`${baseApiUrl}/cargos-e-funcoes${id}`, this.cargo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.cargos = res.data
      })
    },
    loadCargo (cargo, mode = 'save') {
      this.mode = mode
      this.cargo = { ...cargo }
      this.codigo = cargo.id
      this.dialog = false
    },
    reset () {
      this.codigo = ''
      this.mode = 'save'
      this.cargo = {}
    },
    loadDialog () {
      this.dialog = true
      this.loadCargos()
    },
    loadUser () {
      this.cargo.usuario = this.user.id
      this.cargo.uuid = uuid.v1()
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 750px;
}
</style>
